import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from './methods/ants.js';
import 'ant-design-vue/dist/antd.less';
import '@/assets/css/global.css'
import directive from './directive/index.js'
import SearchForm from '@/components/form.vue'
import TableList from '@/components/table.vue'
import upload from '@/components/upload.vue'
import SubmitForm from '@/components/submitForm.vue'
// import '@/assets/css/font.css'

import config from './methods/config.js'
import method from './methods/method.js'
const app = createApp(App)

app.component('SearchForm', SearchForm);
app.component('TableList', TableList);
app.component('Upload', upload);
app.component('SubmitForm', SubmitForm);
for(let key in directive){
    app.directive(key,directive[key])
}
app.config.globalProperties.$config = config;
app.config.globalProperties.$methods = method
app.use(Antd)
app.use(store).use(router).mount('#app')
